import { readable } from 'svelte/store';
import { getDownloadURL, getStorage, listAll, ref } from 'firebase/storage';
import * as L from 'leaflet';
import 'leaflet-gpx/gpx';
import { styles } from '../styles/styles';
export const runs = readable([], function start(set) {
    let runs = [];
    // Get a reference to the storage service, which is used to create references in your storage bucket
    const storage = getStorage();
    // Create a storage reference from our storage service
    const storageRef = ref(storage, 'runs/');
    // Find all the prefixes and items.
    // TODO: async/awai
    listAll(storageRef)
        .then((res) => {
        res.items.forEach((itemRef, i) => {
            getDownloadURL(itemRef).then((url) => {
                // gpx can take a url or a gpx directly, but we're using the firebase url
                const runGpx = new L.GPX(url, {
                    async: true,
                    marker_options: {
                        startIconUrl: '',
                        endIconUrl: '',
                        shadowUrl: '',
                    },
                    polyline_options: {
                        color: '#B155BD',
                        opacity: styles.pathOpacity,
                    },
                });
                runGpx.on('loaded', (e) => {
                    const run = e.target;
                    runs = [
                        ...runs,
                        {
                            gpx: runGpx,
                            data: {
                                name: run.get_name(),
                                start: run.get_start_time(),
                                end: run.get_end_time(),
                                distance: run.get_distance_imp(),
                                pace: run.get_moving_pace_imp(),
                                totalTime: run.get_total_time(),
                            },
                        },
                    ];
                    // reverse sort by date
                    runs.sort((a, b) => b.data.start - a.data.start);
                    // TODO: don't want to be setting this after each run is loaded - better would be to wait till they're all done
                    set(runs);
                });
            });
        });
    })
        .catch(console.error);
    return function stop() { };
});
